import { render, staticRenderFns } from "./GeneralInformation.vue?vue&type=template&id=4a6fe913&scoped=true"
import script from "./GeneralInformation.vue?vue&type=script&lang=js"
export * from "./GeneralInformation.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/panel-simple.css?vue&type=style&index=0&id=4a6fe913&prod&scoped=true&lang=css&external"
import style1 from "./GeneralInformation.vue?vue&type=style&index=1&id=4a6fe913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6fe913",
  null
  
)

export default component.exports